import { Component } from '@angular/core';

@Component({
    selector: 'app-dashboard-card',
    imports: [],
    templateUrl: './dashboard-card.component.html',
    styleUrl: './dashboard-card.component.scss'
})
export class DashboardCardComponent {

}
